module.exports = __webpack_public_path__ + "static/media/Nicoleño_icon_200px.b7d15835.png";